import { render, staticRenderFns } from "./PontoRetaguardaField.vue?vue&type=template&id=17824c7a&scoped=true&"
import script from "./PontoRetaguardaField.vue?vue&type=script&lang=js&"
export * from "./PontoRetaguardaField.vue?vue&type=script&lang=js&"
import style0 from "./PontoRetaguardaField.vue?vue&type=style&index=0&id=17824c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17824c7a",
  null
  
)

export default component.exports